import React, { ReactNode } from 'react';
import classNames from 'classnames';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  Icons,
  Button,
  ToolButton,
} from '../';
import { IconPresentationProvider } from '@ohif/ui-next';

import NavBar from '../NavBar';

// Todo: we should move this component to composition and remove props base

interface HeaderProps {
  children?: ReactNode;
  menuOptions: Array<{
    title: string;
    icon?: string;
    onClick: () => void;
  }>;
  isReturnEnabled?: boolean;
  onClickReturnButton?: () => void;
  isSticky?: boolean;
  WhiteLabeling?: {
    createLogoComponentFn?: (React: any, props: any) => ReactNode;
  };
  PatientInfo?: ReactNode;
  Secondary?: ReactNode;
  UndoRedo?: ReactNode;
}

function Header({
  children,
  menuOptions,
  isReturnEnabled = true,
  onClickReturnButton,
  isSticky = false,
  WhiteLabeling,
  PatientInfo,
  UndoRedo,
  Secondary,
  ...props
}: HeaderProps): ReactNode {
  const onClickReturn = () => {
    if (isReturnEnabled && onClickReturnButton) {
      onClickReturnButton();
    }
  };

  return (
    <IconPresentationProvider
      size="large"
      IconContainer={ToolButton}
    >
      <NavBar
        isSticky={isSticky}
        {...props}
      >
        {/* Ba cụm điều khiển vốn đều position:absolute nên trên điện thoại chúng chồng đè lên nhau và
            phủ kín ảnh. Dưới 768px chuyển sang hàng flex thường: thanh công cụ chính cuộn ngang,
            bánh răng ghim bên phải, các cụm phụ (secondary, undo/redo, thông tin bệnh nhân) ẩn đi.
            Từ md trở lên giữ nguyên bố cục absolute cũ. */}
        <div className="relative flex h-[48px] items-center gap-1 md:block">
          <div className="hidden md:absolute md:left-0 md:top-1/2 md:flex md:-translate-y-1/2 md:items-center">
          </div>
          <div className="hidden md:absolute md:top-1/2 md:left-[250px] md:block md:h-8 md:-translate-y-1/2">{Secondary}</div>
          <div className="min-w-0 flex-1 overflow-x-auto md:absolute md:left-1/2 md:top-1/2 md:w-auto md:flex-none md:-translate-x-1/2 md:-translate-y-1/2 md:transform md:overflow-x-visible">
            <div className="flex w-max items-center justify-center space-x-2 md:w-auto">{children}</div>
          </div>
          <div className="flex flex-shrink-0 select-none items-center md:absolute md:right-0 md:top-1/2 md:-translate-y-1/2">
            <div className="hidden items-center md:flex">
              {UndoRedo}
              <div className="border-muted mx-1.5 h-[25px] border-r"></div>
              {PatientInfo}
              <div className="border-muted mx-1.5 h-[25px] border-r"></div>
            </div>
            <div className="flex-shrink-0">
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button
                    variant="ghost"
                    size="icon"
                    className="text-primary hover:bg-muted mt-2 h-full w-full"
                  >
                    <Icons.GearSettings />
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end">
                  {menuOptions.map((option, index) => {
                    const IconComponent = option.icon
                      ? Icons[option.icon as keyof typeof Icons]
                      : null;
                    return (
                      <DropdownMenuItem
                        key={index}
                        onSelect={option.onClick}
                        className="flex items-center gap-2 py-2"
                      >
                        {IconComponent && (
                          <span className="flex h-4 w-4 items-center justify-center">
                            <Icons.ByName name={option.icon} />
                          </span>
                        )}
                        <span className="flex-1">{option.title}</span>
                      </DropdownMenuItem>
                    );
                  })}
                </DropdownMenuContent>
              </DropdownMenu>
            </div>
          </div>
        </div>
      </NavBar>
    </IconPresentationProvider>
  );
}

export default Header;
